import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from 'pages/Home'
// import MicroSite from 'pages/MicroSite';
// import MicroSiteEventList from 'pages/MicroSiteEventList';
// import MicroSiteEvent from 'pages/MicroSiteEvent';
//WIDGETS
import AddAdmissionGroupWidget from 'pages/Widgets/AddAdmissionGroup'
import EventListWidget from 'pages/Widgets/EventList'
import EventCarouselWidget from 'pages/Widgets/EventCarousel'
import EventCalendarWidget from 'pages/Widgets/EventCalendar'
import InventoryListWidget from 'pages/Widgets/InventoryList'
import InventoryListMapWidget from 'pages/Widgets/InventoryListMap'
import CheckoutModalWidget from 'pages/Widgets/CheckoutModal'
import EventDetailWidget from 'pages/Widgets/EventDetail'
import EventFlyerWidget from 'pages/Widgets/EventFlyer'
import MembershipWidget from 'pages/Widgets/Membership'
import MembershipStart from 'components/MembershipStart'
import MembershipSelectPlan from 'components/MembershipSelectPlan'
import MembershipCheckout from 'components/MembershipCheckout'
import MembershipSuccess from 'components/MembershipSuccess'
import MembershipPerks from 'components/MembershipPerks'
import MembershipPerksInventory from 'components/MembershipPerksInventory'
import MembershipPerksCheckout from 'components/MembershipPerksCheckout'
import VenueApp from 'pages/Venue/VenueApp'
import VenueAppHome from 'pages/Venue/VenueAppHome'
import VenueAppEvent from 'pages/Venue/VenueAppEvent'
import VenueAppEvents from 'pages/Venue/VenueAppEvents'
import VenueAppCheckout from 'pages/Venue/VenueAppCheckout'
import VenueAppCheckoutComplete from 'pages/Venue/VenueAppCheckoutComplete'
import ExpressCheckout from 'pages/ExpressCheckout'
import ExpressCheckoutComplete from 'pages/ExpressCheckoutComplete'
//
import ChatApp from 'pages/Widgets/Chat/ChatApp'
import ChatAppGuest from 'pages/Widgets/Chat/ChatAppGuest'
import ChatAppHome from 'pages/Widgets/Chat/ChatAppHome'
import ChatAppLogin from 'pages/Widgets/Chat/ChatAppLogin'
//
import ROUTE_NAMES from 'constants/routeNames'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/venues/:venueId',
    name: 'VenueApp',
    component: VenueApp,
    redirect: '/venues/:venueId/home',
    children: [
      {
        name: 'VenueAppHome',
        path: '/venues/:venueId/home',
        component: VenueAppHome,
      },
      {
        name: 'VenueAppEvents',
        path: '/venues/:venueId/events',
        component: VenueAppEvents,
      },
      {
        name: 'VenueAppEvent',
        path: '/venues/:venueId/events/:eventId',
        component: VenueAppEvent,
      },
      {
        name: 'VenueAppCheckout',
        path: '/venues/:venueId/checkout',
        component: VenueAppCheckout,
      },
      {
        name: 'VenueAppCheckoutComplete',
        path: '/venues/:venueId/checkout-complete',
        component: VenueAppCheckoutComplete,
      },
    ],
  },
  {
    path: '/express-checkout',
    name: 'ExpressCheckout',
    component: ExpressCheckout,
  },
  {
    path: '/express-checkout-complete',
    name: 'ExpressCheckoutComplete',
    component: ExpressCheckoutComplete,
  },
  //WIDGETS
  {
    path: '/widgets/add-admission-group',
    name: 'AddAdmissionGroupWidget',
    component: AddAdmissionGroupWidget,
  },
  {
    path: '/widgets/event-list',
    name: 'EventListWidget',
    component: EventListWidget,
  },
  {
    path: '/widgets/event-carousel',
    name: 'EventCarouselWidget',
    component: EventCarouselWidget,
  },
  {
    path: '/widgets/event-calendar',
    name: 'EventCalendarWidget',
    component: EventCalendarWidget,
  },
  {
    path: '/widgets/inventory-list',
    name: 'InventoryListWidget',
    component: InventoryListWidget,
  },
  {
    path: '/widgets/inventory-list-map',
    name: 'InventoryListMapWidget',
    component: InventoryListMapWidget,
  },
  {
    path: '/widgets/checkout-modal',
    name: 'CheckoutModal',
    component: CheckoutModalWidget,
  },
  {
    path: '/widgets/event-detail',
    name: 'EventDetailWidget',
    component: EventDetailWidget,
  },
  {
    path: '/widgets/event-flyer',
    name: 'EventFlyerWidget',
    component: EventFlyerWidget,
  },
  {
    path: '/widgets/membership',
    name: 'MembershipWidget',
    component: MembershipWidget,
    redirect: '/widgets/membership/start',
    children: [
      {
        name: 'MembershipStart',
        path: '/widgets/membership/start',
        component: MembershipStart,
      },
      {
        name: 'MembershipSelectPlan',
        path: '/widgets/membership/select-plan',
        component: MembershipSelectPlan,
      },
      {
        name: 'MembershipCheckout',
        path: '/widgets/membership/checkout',
        component: MembershipCheckout,
      },
      {
        name: 'MembershipSuccess',
        path: '/widgets/membership/thanks',
        component: MembershipSuccess,
      },
      {
        name: 'MembershipPerks',
        path: '/widgets/membership/perks',
        redirect: '/widgets/membership/perks/inventory',
        component: MembershipPerks,
        children: [
          {
            name: 'MembershipPerksInventory',
            path: '/widgets/membership/perks/inventory',
            component: MembershipPerksInventory,
          },
          {
            name: 'MembershipPerksCheckout',
            path: '/widgets/membership/perks/checkout',
            component: MembershipPerksCheckout,
          },
        ],
      },
    ],
  },
  {
    path: '/chat-widget',
    name: ROUTE_NAMES.CHAT_APP,
    component: ChatApp,
    redirect: '/chat-widget/home',
    children: [
      {
        path: '/chat-widget/guest',
        name: ROUTE_NAMES.CHAT_APP_GUEST,
        component: ChatAppGuest,
      },
      {
        path: '/chat-widget/login',
        name: ROUTE_NAMES.CHAT_APP_LOGIN,
        component: ChatAppLogin,
      },
      {
        path: '/chat-widget/home',
        name: ROUTE_NAMES.CHAT_APP_HOME,
        component: ChatAppHome,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
})

export default router



// WEBPACK FOOTER //
// ./src/router.js